import {Type} from '@angular/core';

export const tableColumnTypes: { [key: string]: any } = {};

export function GnTableColumn(key: string) {
  return (target: Type<any>) => {
    tableColumnTypes[key] = target;
  };
}
